import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-monitor-landing',
    templateUrl: './monitor-landing.component.html',
    styleUrls: ['./monitor-landing.component.css'],
    standalone: false
})
export class MonitorLandingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
